import { inject, Injectable, ViewContainerRef } from '@angular/core';
import { AuthService } from '../../pages/auth/services/auth.service';
import { Plugin } from '../../shared/models/logged-in-user';
import { components, loadComponents } from '../plugins';

@Injectable({
  providedIn: 'root',
})
export class LazyWidgetLoaderService {
  private authService = inject(AuthService);
  private pluginDetails: Plugin[] | undefined;
  private initialized = false;

  async initialize() {
    if (this.initialized) {
      return;
    }
    await loadComponents(); // Load all components once during app initialization
    this.initialized = true;
  }

  private _getPluginDetails(): Plugin[] {
    if (this.pluginDetails === undefined) {
      const userInfo = this.authService.getLoggedInUserInfo();
      this.pluginDetails = userInfo?.plugins;
    }

    return this.pluginDetails as Plugin[];
  }

  async loadWidget(
    areaCode: string,
    viewContainerRef: ViewContainerRef,
    inputData?: object, // Optional data to pass to the component
  ): Promise<void> {
    await this.initialize();
    const details = this._getPluginDetails();
    const key_name = details.find((plugin) => plugin.area_code === areaCode)
      ?.widget_key_name as string;

    const component = components[key_name];
    if (!component) {
      console.error('Component not found for key:', key_name);
      return;
    }

    const componentRef = viewContainerRef.createComponent(component);

    // Pass input data to the component if provided
    if (inputData) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Object.assign(componentRef.instance as any, inputData);
    }
  }
}
